const SDK_VERSION = '8.13.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
